// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"4460":"9758027a9374700d1589","5945":"827f9b00ef689ee9adb2","7925":"5b6d8ea15761edd7112d"}[chunkId] + ".js";
};